import { render } from "./GoogleAutocomplete.vue?vue&type=template&id=2c054d48"
import script from "./GoogleAutocomplete.vue?vue&type=script&lang=js"
export * from "./GoogleAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__